import styled from 'styled-components';
import { SideNavColorSchemeIndex, SideNavColorSchemeProps } from '../..';
import { localTheme } from '../../../../styles/local-theme';

const textColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.iceGray,
  blue: localTheme.colors.paleBlue,
};

const NoResult = styled.div<SideNavColorSchemeProps>`
  color: ${(props): string => textColorSchemes[props.colorScheme]};
  padding: ${(props): string => props.theme.spaces.lg};
`;

export { NoResult };
